
/**
 * Directive to add extra reset functions to the scope. This is used to reset specific filters using the
 * filter tags.
 */
angular.module('westBerkshireEvents.filterTags').directive('wbFilterTagsTest', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        controller: WbFilterTagsController
    };
});

function WbFilterTagsController($scope, $attrs, $rootScope, QueryStringService, $location) {
    $scope.paymentComplete = QueryStringService('status') === false ? false : true;

    $scope.resetDateFilter = function () {
        delete $scope.filters.date;
        $scope.filterChanged();

        delete $scope.selected_date;
        $rootScope.$broadcast('event_list_filter_date:cleared');
    };

    $scope.resetDynamicFilter = function (filter) {
        $scope.dynamic_filters.values[filter.name] = null;
        $location.search(filter.name.toLocaleLowerCase().replace(' ', '_'), null); // set specific filter to null
        $scope.generateSummary($scope.items);
        $scope.filterChanged();
    };

    $scope.resetEventGroupFilter = function () {
        delete $scope.filters.event_group;
        $scope.generateSummary($scope.items);
        $scope.filterChanged();
    };
}


// WEBPACK FOOTER //
// ../src/public/javascripts/filter-tags/filter_tags.directive.js